var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconMessage24 = function SvgAIconMessage24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8 17.4H11.4L6.6 21V17.4H4.2C3.53726 17.4 3 16.8627 3 16.2V4.2C3 3.53726 3.53726 3 4.2 3H19.8C20.4627 3 21 3.53726 21 4.2V16.2C21 16.8627 20.4627 17.4 19.8 17.4Z",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAIconMessage24 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTkuOCAxNy40SDExLjRMNi42IDIxVjE3LjRINC4yQzMuNTM3MjYgMTcuNCAzIDE2Ljg2MjcgMyAxNi4yVjQuMkMzIDMuNTM3MjYgMy41MzcyNiAzIDQuMiAzSDE5LjhDMjAuNDYyNyAzIDIxIDMuNTM3MjYgMjEgNC4yVjE2LjJDMjEgMTYuODYyNyAyMC40NjI3IDE3LjQgMTkuOCAxNy40WiIgc3Ryb2tlLXdpZHRoPSIxLjgiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPC9zdmc+Cg==";